angular.module('gc.askpopin', ['gc.user'])
.controller("AskEmailPopinController", [
'$rootScope',
'GcUser',
'$scope',
'$log',
'$location',
'$timeout',
'BASE_URL',
function ($rootScope, GcUser, $scope, $log, $location, $timeout, BASE_URL) {
  'use strict';

  if (!$scope.user || !$scope.user.validation) return;

  $scope.GcUser = GcUser;
  $scope.popinUser = {
    email: $scope.user.validation.v_email
  };
  $scope.forgotUrl = BASE_URL + '/admin/#/forgot';

  $scope.visibleForm = function () {
    return $scope.user && $scope.user.validation && $scope.user.validation.v_email ? 'token' : 'email';
  };

  $scope.saveEmail = function () {
    $scope.errorValidation = null;
    $scope.tokenResent = null;

    if (!$scope.user.validation || !$scope.user.validation.v_email) {
      $location.url('');
    }

    return GcUser.update({ email:$scope.popinUser.email }, function (err) {
      if (err) {
        $scope.errorValidation = 'valid email already exist';
      } else {
        if ($scope.visibleForm() === 'email') {
          $rootScope.showAskEmailPopin = false;
        }
        $scope.token = '';
      }
    });
  };

  $scope.resendToken = function () {
    GcUser.resendToken().success(function () {
      $scope.tokenResent = true;
    });
  };

  $scope.validEmail = function () {
    $scope.errorValidation = null;
    $scope.tokenResent = null;

    // angular automatically converts token to a number,
    // if token starts with a zero it will be removed,
    // we access the value directly to avoid that.
    var token = document.querySelector('form[name=askTokenForm] input[type=number]').value;

    GcUser.validEmail($scope.popinUser.email, token, function(errMessage) {
      if (errMessage) {
        $log.debug(errMessage);
        // if it's a token problem, try again
        if (errMessage.indexOf('validation') !== -1) {
          $scope.errorValidation = 'email validation failed';
        } else if (errMessage.indexOf('token bad format') !== -1) {
          $scope.errorValidation = errMessage;
        } else if (errMessage.indexOf('email') !== -1) {
          $scope.errorValidation = 'valid email already exist';
        }
        return;
      }

      mixpanel.track('auth:token_validated');
      $scope.close();
    });
  };

  $scope.close = function() {
    $timeout(function () {
      $rootScope.showAskEmailPopin = false;
    });
  };

  // We close the askEmail$scope if the logged user log out
  $rootScope.$on('logged_out', function() {
    $scope.close();
  });

}])
.directive('askEmailPopin', [function () {
  'use strict';
  return {
    scope: {
      user: "="
    },
    controller: "AskEmailPopinController",
    controllerAs: "popin",
    restrict: 'AE',
    templateUrl: 'askEmailPopin.html',
    link: function ($scope, el, attrs, controller) {
      controller.user = $scope.user;
      controller.token = $scope.token;
    }
  };
}]);
